module.exports = __webpack_public_path__ + "img/logo-2.d1841cd4.png";